/* Coș lateral Legacy: butoane "+ Adaugă" (recomandare / coș gol) și cod de reducere.
   Folosește același mecanism ca product-form.js: POST /cart/add cu "sections",
   apoi cart-drawer.renderContents(). Delegare pe document, deci funcționează și după re-randare. */
(function () {
  if (window.__lomCartDrawer) return;
  window.__lomCartDrawer = true;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function showError(message) {
    var box = document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = message || (window.cartStrings && window.cartStrings.error) || '';
  }

  function addToCart(btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var drawer = getDrawer();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        drawer.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append('sections_url', window.location.pathname);
    }

    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          showError(response.description || response.message);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-loading');
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(response);
          setTimeout(function () {
            var inner = document.querySelector('#CartDrawer .drawer__inner');
            if (typeof trapFocus === 'function' && inner) trapFocus(document.getElementById('CartDrawer'), inner);
          }, 50);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // source 'cart-items' = sertarul nu se mai re-randează încă o dată, dar ceilalți abonați află
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: response, variantId: variantId });
        }
        document.dispatchEvent(new CustomEvent('cartUpdated', { detail: { message: 'Cart was updated' } }));
      })
      .catch(function (e) {
        console.error(e);
        showError();
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-loading');
      });
  }

  function applyCode() {
    var input = document.querySelector('[data-lcd-code-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      input.focus();
      return;
    }
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-lcd-add]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn);
      return;
    }
    var toggle = e.target.closest('[data-lcd-code-toggle]');
    if (toggle) {
      e.preventDefault();
      var box = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!box) return;
      var open = box.hasAttribute('hidden');
      box.toggleAttribute('hidden', !open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Legacy: nu punem focus în câmp, ca tastatura să apară doar când clientul atinge câmpul.
      return;
    }
    if (e.target.closest('[data-lcd-code-apply]')) {
      e.preventDefault();
      applyCode();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-lcd-code-input]')) {
      e.preventDefault();
      applyCode();
    }
  });
})();

/* Legacy: recomandările din coș se rotesc la nesfârșit (după ultimul produs vine iar primul).
   Produsele se dublează o dată, la primul swipe; când ajungi la copie, poziția sare înapoi fără să se vadă. */
(function () {
  if (window.__lomCartLoop) return;
  window.__lomCartLoop = true;
  function setup(row) {
    if (row.dataset.lcdLoop) return true;
    var items = Array.prototype.slice.call(row.children);
    if (items.length < 2 || row.scrollWidth <= row.clientWidth + 4) { row.dataset.lcdLoop = 'off'; return false; }
    items.forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a, button').forEach(function (n) { n.setAttribute('tabindex', '-1'); });
      row.appendChild(c);
    });
    row.dataset.lcdLoop = 'on';
    row.__lcdPeriod = row.children[items.length].offsetLeft - row.children[0].offsetLeft;
    return true;
  }
  document.addEventListener('scroll', function (e) {
    var row = e.target;
    if (!row || !row.classList || !row.classList.contains('lcd__recs')) return;
    if (!setup(row) || row.dataset.lcdLoop !== 'on') return;
    var p = row.__lcdPeriod;
    if (p > 0 && row.scrollLeft >= p) {
      row.style.scrollSnapType = 'none';
      row.scrollLeft -= p;
      requestAnimationFrame(function () { row.style.scrollSnapType = ''; });
    }
  }, true);
})();
